import store from "@frameworks/web/redux/store";
import { MULTI_QUOTE_DATA, MULTI_QUOTE_ERROR_DATA, MULTI_QUOTE_HIDE_ERROR_DATA, MULTI_QUOTE_START_LOADER, MULTI_QUOTE_STOP_LOADER, } from "../interface/IMultiQuote";
export default class MultiQuoteActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getMultiQuoteData(multiQuote) {
        this.dispatch({
            type: MULTI_QUOTE_DATA,
            payload: { multiQuote },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: MULTI_QUOTE_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: MULTI_QUOTE_HIDE_ERROR_DATA,
        });
    }
    startMultiQuoteloader() {
        this.dispatch({
            type: MULTI_QUOTE_START_LOADER,
        });
    }
    stopMultiQuoteLoader() {
        this.dispatch({
            type: MULTI_QUOTE_STOP_LOADER,
        });
    }
}
